import { isValid, parse } from 'date-fns';

import { DATE_FORMAT } from '../../components/DatePicker/constants';

// @todo Move out from formatting
export default (formattedDateString: string) => {
    const date = parse(formattedDateString, DATE_FORMAT, new Date());
    return isValid(date) ? date : null;
};
